module.exports = __webpack_public_path__ + "static/media/transparency.f62e1960.png";